module.exports = __webpack_public_path__ + "static/expertise-illustration-66b2987c206f9216e2c99f5c3317207e.svg";